/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
// eyJ0eXAiOiJKV1QiLCJub25jZSI6IlZCYjl5bG1xMGRPSk5ETXNEN0U0Q1RZemtHRUUySUlVNDF4a0pGTGplQTQiLCJhbGciOiJSUzI1NiIsIng1dCI6IktRMnRBY3JFN2xCYVZWR0JtYzVGb2JnZEpvNCIsImtpZCI6IktRMnRBY3JFN2xCYVZWR0JtYzVGb2JnZEpvNCJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC9hOTVhNzg1Ny1kNmY2LTRiMjgtOTEwZC0xZGQ2MzI5NTU2NGIvIiwiaWF0IjoxNzIzNjcxMDQyLCJuYmYiOjE3MjM2NzEwNDIsImV4cCI6MTcyMzY3NjU5NSwiYWNjdCI6MCwiYWNyIjoiMSIsImFpbyI6IkFWUUFxLzhYQUFBQVhrRDhrNm5jNXJaK3hPVzQ5SUQzRzFBYmpKekJtalp1aEJvTDRPQkZmT0s3VGdmYldHZDlzRWZyZGtNU09icU0vQUh6MGFiSTJuTkxuRmplOGxzZXY1eVBWWTRJVE1IMHIvcHI3cldLbDY4PSIsImFtciI6WyJwd2QiLCJtZmEiXSwiYXBwX2Rpc3BsYXluYW1lIjoiUlMtQ29ubmVjdCIsImFwcGlkIjoiZGZlOTdjMDAtMzQ0Ni00YTg4LTg5M2QtZDI2OTllOWQyY2QyIiwiYXBwaWRhY3IiOiIwIiwiZmFtaWx5X25hbWUiOiJIb292ZXIiLCJnaXZlbl9uYW1lIjoiRHlsYW4iLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiIyNC4yMy4xOTAuMjQ5IiwibmFtZSI6IkR5bGFuIEhvb3ZlciIsIm9pZCI6IjFlOTM2NDM4LTg2YWEtNDMyOS04OGQ5LWQ0NTAyMWQ5NDZiNSIsInBsYXRmIjoiMyIsInB1aWQiOiIxMDAzMjAwMTU1NERGRTdGIiwicmgiOiIwLkFRZ0FWM2hhcWZiV0tFdVJEUjNXTXBWV1N3TUFBQUFBQUFBQXdBQUFBQUFBQUFEWEFGOC4iLCJzY3AiOiJvcGVuaWQgcHJvZmlsZSBVc2VyLlJlYWQgZW1haWwiLCJzdWIiOiJWRmxtSWNTNm5VR1c0UVhMWjlKcGdITG1GX21MSXkya1RSLUZYWHpQd3FRIiwidGVuYW50X3JlZ2lvbl9zY29wZSI6Ik5BIiwidGlkIjoiYTk1YTc4NTctZDZmNi00YjI4LTkxMGQtMWRkNjMyOTU1NjRiIiwidW5pcXVlX25hbWUiOiJkaG9vdmVyQHNhZmVpbmhvbWUuY29tIiwidXBuIjoiZGhvb3ZlckBzYWZlaW5ob21lLmNvbSIsInV0aSI6ImhZZzZEc1ZRUFVDeXlHT25kVEg0QUEiLCJ2ZXIiOiIxLjAiLCJ3aWRzIjpbIjE1OGMwNDdhLWM5MDctNDU1Ni1iN2VmLTQ0NjU1MWE2YjVmNyIsIjliODk1ZDkyLTJjZDMtNDRjNy05ZDAyLWE2YWMyZDVlYTVjMyIsIjg5MmM1ODQyLWE5YTYtNDYzYS04MDQxLTcyYWEwOGNhM2NmNiIsIjExMmNhMWEyLTE1YWQtNDEwMi05OTVlLTQ1YjBiYzQ3OWE2YSIsImNmMWMzOGU1LTM2MjEtNDAwNC1hN2NiLTg3OTYyNGRjZWQ3YyIsImI3OWZiZjRkLTNlZjktNDY4OS04MTQzLTc2YjE5NGU4NTUwOSJdLCJ4bXNfaWRyZWwiOiIxIDE0IiwieG1zX3N0Ijp7InN1YiI6Iml5WXUycFhQRE5xSGNCVHdnN0p3QTNtU0RYUnlIRURmS3dtcmwycUM4bUUifSwieG1zX3RjZHQiOjEzNDk5MjY3OTh9.AkaHfjkNpksE7kGQaPFyApdnuLGNqQrYQO5nH1jqQz4LHLqh7DYClB3EUqdtSpyhqgCzDZhKeVMmdiRYqNj_1CdoR0qJRarylIvqyCM4Z1YJer6B9dD6kYfVDuTXt3kfvbz0g4-JH8qvg9Y79r-PX6utP5T7N25kOGSKA5D74wEzL50YXElACPD_VLuOsiUZDMC7mhU-3_Gy3DaDiu8wM9H0RsUzUgJV0onVwa4puOJD_VRndbV5nqnKRZG4mM5XE_ihs-hHNTm2SzuSnuVHBllYOosVVZ76lX9moZdAUJdiiZCWL_oJurDYZb_wVlU8UkZg-12nHPx2_LK4uDZUvg
export const msalConfig = {
    auth: {
        // clientId: "dfe97c00-3446-4a88-893d-d2699e9d2cd2",
        clientId: "e9bdc91b-7b21-4675-befb-af75659de2c0",
        authority: "https://login.microsoftonline.com/a95a7857-d6f6-4b28-910d-1dd63295564b",
        // redirectUri: "http://localhost:3000",
        redirectUri: `${process.env.REACT_APP_SSO_REDIRECT_URI}`
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["api://e9bdc91b-7b21-4675-befb-af75659de2c0/Api.Use"]
};
